import React from 'react';
import Icon from './Icon';

export default function SearchBox({ value, onChange, placeholder = 'Search…' }) {
  return (
    <label className="search-box">
      <Icon name="search" size={15} />
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button type="button" onClick={() => onChange('')} aria-label="Clear search">
          ×
        </button>
      )}
    </label>
  );
}
